import PageTitle from "./pageTitle";
import { useContext } from "react";
import { CompanyInfoContext } from "../../App";
import parse from "html-react-parser";
import { Helmet } from "react-helmet-async";

const Privacy = () => {
    const companyInfo = useContext(CompanyInfoContext);

    return (
        <section>
            <Helmet>
                <title>Our Privacy Statement - Codehub Technologies</title>
            </Helmet>

            <PageTitle title="Our Privacy Statement" />

            <div className="cht-min-h-[60vh] cht-bg-slate-50/40 !cht-font-body">
                <div className="cht-max-w-4xl cht-mx-auto cht-px-4 sm:cht-px-6 lg:cht-px-8 cht-py-12 sm:cht-py-16">
                    <div className="cht-bg-white cht-rounded-[24px] cht-border cht-border-slate-200/80 cht-shadow-soft cht-p-6 sm:cht-p-10 sm:cht-p-12 cht-prose cht-max-w-none">
                        {parse(`${companyInfo.privacy_policy}`)}
                    </div>
                </div>
            </div>
        </section>
    );
};

export default Privacy;
